<template>
  <div class="modal-backdrop" v-if="show">
    <div class="modal">
      <form>
        <h4 class="Gtitle">
          Vous recevez toutes les nouvelles annonces immobilières qui
          correspondront à vos critères actuels
        </h4 >
        <h5 class="Stitle">Nommez-vous alerte pout la retrouver facilement*</h5>
        <div class="content_input"><Input
          v-model="Alert.alert_name"
          datatype="text"
          placeholder="Nom de l'alert"
        />
        </div>
        <div class="content_btn">
          <button type="button" class="btn" @click="change">
            <fa-icon :icon="{ prefix: 'fas', iconName: 'bell' }" /> Enregistrer
          </button>
        </div>
      </form>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import Input from "./Input";
//import { mapActions, mapGetters, mapMutations } from "vuex";
export default {
  data() {
    return {
      Alert:{
        alert_name:null,
        searchQuery:{},
        total_result:0
      },
    };
  },
  props:{
      show:{
          type:Boolean
      },
      searchquery:{
          type:Object
      },
      totalrows:{
          type:Number
      },
  },
  methods: {
    ...mapActions(['addAlert','whoami','saveAlert']),
    change() {
     let payload = {
       "name": this.Alert.alert_name,
       "user_email" : localStorage.getItem("email-user"),
       "project_id" : localStorage.getItem("project_id"),
       "dossier": localStorage.getItem("dossier"),
       "search_query": this.searchQuery,
       "total_result": this.total_result,
     }
        if(this.Alert!==null){
          this.$loading(true)
            this.saveAlert({payload: payload}).then(res => {
              console.log(res)
              this.$loading(false)
              this.Alert.alert_name = null
            }).then(err => {
              console.log(err)
            })
        }
        this.$emit('change')
    },
  },
  components: {
    Input,
  },
  watch: {
    show: {
      // the callback will be called immediately after the start of the observation
      immediate: true,
      handler: function(show) {
        if (show) {
          //desactive scroll in body
          document.body.style.setProperty("overflow", "hidden");
        } else {
          document.body.style.removeProperty("overflow");
        }
      },
    },
    searchquery(value){
      this.searchQuery = value
    },
    totalrows(value){
      this.total_result = value
    }
  },
  computed: {
    ...mapGetters(["CurrentUser"])
  }
};
</script>
<style scoped lang="scss">
.modal-backdrop {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
  .modal {
    margin-left: auto;
    margin-right: auto;
    max-width: 30%;
    margin-top: 2%;
    background-color: #fff;
    border-radius: 3px;
    padding: 30px;
    box-shadow: 0 15px 30px 0 rgba(0, 0, 0, 0.11);
    .Gtitle{
        text-align: left;
        color :#068596ba;
    }
    .Stitle{
        text-align: left;
        color:#565656ba;
    }
    .content_input{
         text-align: center;
         .row{
             margin:0px;
             margin-bottom: 10px;
         }
    }
    .content_btn {
        text-align: center;
      .btn {
        border-radius: 5px;
        border: none;
        width: 90%;
        color: white;
        background-color: #068596ba;
        padding: 10px;
        outline: 0;
        &:focus {
          border: none;
          background-color: #ff8c00;
        }
      }
    }
  }
}
@media screen and (max-width: 768px) {
  .modal-backdrop{
    .modal{
      max-width: 40%;
      margin-top: 15%;
    }
  }
}
</style>
